import { useLayoutEffect, useState } from "react";
import { createContainer } from "unstated-next";
import { useGlobalStore } from "@/store/GlobalStore";
import { AuthStatus } from "project-config/constants";
import { CertifyStatus } from "../view/certify-card/constants/certify-status";

export function useCertifyStoreHook() {
  const [loading, setLoading] = useState(true);
  const {
    isDomestic,
    userInfo,
    isPersonal,
    isStudentValid,
    studentCertifyInfo,
  } = useGlobalStore();
  const [certifyStatus, setCertifyStatus] = useState(CertifyStatus.NoCertified);

  const updateCertifyState = () => {
    if (!userInfo) return;
    switch (userInfo.authStatus) {
      case AuthStatus.NoCertified:
        setCertifyStatus(CertifyStatus.NoCertified);
        break;
      case AuthStatus.Changing:
        setCertifyStatus(
          isPersonal
            ? CertifyStatus.PersonChangeEnterprise
            : CertifyStatus.EnterpriseChange
        );
        break;
      case AuthStatus.EnterpriseAuthSuccess:
        setCertifyStatus(CertifyStatus.EnterprisePassed);
        break;
      case AuthStatus.PersonalAuthSuccess:
        if (studentCertifyInfo?.noStudentVerify) {
          setCertifyStatus(CertifyStatus.PersonPassed);
          return;
        }
        if (!studentCertifyInfo?.noStudentVerify) {
          setCertifyStatus(
            isStudentValid
              ? CertifyStatus.StudentPassed
              : CertifyStatus.StudentExpire
          );
        }
        if (studentCertifyInfo?.studentVerifyFailed) {
          setCertifyStatus(CertifyStatus.StudentFail);
        }
        if (studentCertifyInfo?.studentVerifyPending) {
          setCertifyStatus(CertifyStatus.StudentPending);
        }
        break;
      case AuthStatus.PendingReview:
      case AuthStatus.PersonUnderReview:
        setCertifyStatus(CertifyStatus.PersonPending);
        break;
      case AuthStatus.EnterpriseUnderReview:
        setCertifyStatus(CertifyStatus.EnterprisePending);
        break;
      case AuthStatus.PersonalAuthFailed:
        setCertifyStatus(CertifyStatus.PersonFailed);
        break;
      case AuthStatus.EnterpriseAuthFail:
        setCertifyStatus(CertifyStatus.EnterpriseFailed);
        break;
      case AuthStatus.PersonaChangeFailed:
        setCertifyStatus(CertifyStatus.PersonaChangeFailed);
        break;
      case AuthStatus.EnterpriseChangeFailed:
        setCertifyStatus(CertifyStatus.EnterpriseChangeFailed);
        break;
      case AuthStatus.PersonalToEnterpriseFailed:
        setCertifyStatus(CertifyStatus.PersonalToEnterpriseFailed);
        break;
      case AuthStatus.PersonalChanging:
        setCertifyStatus(CertifyStatus.PersonalChanging);
        break;
      default:
        break;
    }
    if (!isDomestic) {
      setCertifyStatus(CertifyStatus.EnterpriseFox);
    }
  };

  useLayoutEffect(() => {
    setLoading(true);
    updateCertifyState();
    setLoading(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return {
    loading,
    certifyStatus,
    updateCertifyState,
    setLoading,
  };
}

const CertifyStoreContainer = createContainer(useCertifyStoreHook);

export const CertifyStoreProvider = CertifyStoreContainer.Provider;

export function useCertifyStore() {
  return CertifyStoreContainer.useContainer();
}
